module.exports = __webpack_public_path__ + "media/packs/images/search/calendar-c578176e365cdfa246d761d342ea3717.svg";